import i18n from 'i18next';

/**
 * Read a boolean feature flag from the i18n bundle (served per-collection via
 * rule_set.i18n.variables). i18next's deepExtend can't overwrite non-string
 * primitive leaves, so these flags must NOT be seeded in any default bundle —
 * a seeded true/false would block the server override. A missing key resolves
 * to false (default off).
 */
export const readBool = (key: string): boolean => {
  const bundle: any = i18n.getResourceBundle(i18n.language || 'en', 'translation');
  const value = key.split('.').reduce<any>(
    (acc, part) => (acc != null ? acc[part] : acc),
    bundle,
  );
  return value === true;
};

export default readBool;
